// https://github.com/Thamodaran/react-read-more-less
// ISC License

// Copyright (c) [2018], [Thamodaran]

// Permission to use, copy, modify, and/or distribute this software for any
// purpose with or without fee is hereby granted, provided that the above
// copyright notice and this permission notice appear in all copies.

// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

import { Component } from 'react';
import PropTypes from 'prop-types';

class ReadMore extends Component {
  constructor(props) {
    super(props);
    this.state = {
      charLimit: props.charLimit,
    };
    this.initialState = this.state;
  }

  getReadMoreContent() {
    const { charLimit } = this.state;
    const { children, readMoreText, readLessText } = this.props;
    if (children.length > charLimit) {
      return (
        <span className='short-text'>
          {children.substr(0, charLimit)}...
          <span
            className='readMoreText'
            style={{ color: '#007bff', cursor: 'pointer' }}
            role='presentation'
            onClick={this.showLongText.bind(this)}
          >
            {readMoreText}
          </span>
        </span>
      );
    } else if (children.length < charLimit) {
      return <span className='short-text'>{children}</span>;
    }
    return (
      <span className='short-text'>
        {children}
        <span
          className='readMoreText'
          style={{ color: '#007bff', cursor: 'pointer' }}
          role='presentation'
          onClick={this.showShortText.bind(this)}
        >
          {readLessText}
        </span>
      </span>
    );
  }

  preventEventBubbling(e) {
    if (!this.props.wantEventBubbling) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  showLongText(e) {
    const { children } = this.props;

    this.preventEventBubbling(e);

    this.setState({ charLimit: children.length });
    this.getReadMoreContent();
  }

  showShortText(e) {
    this.preventEventBubbling(e);

    this.setState(this.initialState);
    this.getReadMoreContent();
  }

  render() {
    return <div>{this.getReadMoreContent()}</div>;
  }
}

ReadMore.propTypes = {
  charLimit: PropTypes.number,
  readMoreText: PropTypes.object,
  readLessText: PropTypes.object,
  wantEventBubbling: PropTypes.bool,
  children: PropTypes.string.isRequired,
};
ReadMore.defaultProps = {
  charLimit: 150,
  readMoreText: 'Read more',
  readLessText: 'Read less',
  wantEventBubbling: true,
};
export default ReadMore;